module.exports = __webpack_public_path__ + "img/duck.5705ff12.jpg";